import React from 'react';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Navigate,
	Outlet,
	Route,
	RouterProvider,
} from 'react-router-dom';
import './App.css';
import {
	Dashboard,
	Lookup,
	Home,
	Property,
	DistrictDashboard,
	CustomSearch,
	DistrictSearchInput,
	MyDashboard,
} from '@pages';
import { DistrictSeachResult } from '@/./pages/customSearch/components';
import { AppString } from '@utils';

const PrivateRoute = () => {
	const token = localStorage.getItem(AppString.user_token);
	return token ? <Outlet /> : <Navigate to="/" replace />;
};

function App() {
	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route>
				<Route path="/" element={<Dashboard />}>
					<Route path="/" element={<Home />} />
					{/* Protected Routes */}
					<Route element={<PrivateRoute />}>
						<Route path="/me" element={<MyDashboard />} />
					</Route>
					<Route path="/lookup" element={<Lookup />} />
					<Route path="/property" element={<Property />} />
					<Route path="/district-dashboard" element={<DistrictSearchInput />} />
					<Route
						path="/district-dashboard/:module/:id"
						element={<DistrictDashboard />}
					/>
					<Route path="/search" element={<CustomSearch />} />
					<Route path="/search/:module/:id" element={<DistrictSeachResult />} />
					{/* Redirect unknown routes */}
					<Route path="*" element={<Navigate to="/" />} />
				</Route>
			</Route>
		)
	);

	return <RouterProvider router={router}></RouterProvider>;
}

export default App;
